export default __webpack_public_path__ + "static/media/shopping-basket.dfda63d6.svg";